import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { ProviInfographic } from '../components/ProviInfographic';
import { OfferCard } from '../components/OfferCard';
import { FooterCTA } from '../components/FooterCTA';
export function About() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-176">
      {/* SECTION 1 — HERO DESPRE MINE */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-16 md:py-24" data-id="element-177">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-178"></div>
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-179">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-180">
            <div data-id="element-181">
              <div className="inline-flex items-center gap-2 bg-[rgba(255,255,255,0.03)] border border-[rgba(255,255,255,0.08)] backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-182">
                <span className="font-['Montserrat'] text-[11px] font-bold tracking-[0.18em] uppercase text-[#3B82F6]" data-id="element-183">
                  IMPLEMENTARE SISTEME DE BUSINESS
                </span>
              </div>
              <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-4" data-id="element-184">
                Valer Dura
              </h1>
              <p className="font-['Montserrat'] text-[18px] font-semibold text-[#3B82F6] mb-8" data-id="element-185">
                Fondator PROVI System . Arhitect de Sisteme Antreprenoriale
                Scalabile & Vandabile .
              </p>
              <p className="font-['Inter'] text-[20px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] italic border-l-4 border-[#1D4ED8] pl-6" data-id="element-186">
                "Nu vin să îți spun ce să faci. Vin în compania ta, lucrez cu
                oamenii tăi și construiesc, alături de tine, sistemul care face
                afacerea să meargă fără să fii tu prezent în fiecare zi."
              </p>
            </div>
            <div className="relative" data-id="element-187">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-188"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl" data-id="element-189" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — DE CE FAC CE FAC */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-190">
        <div className="max-w-[800px] mx-auto px-5 md:px-12 text-center" data-id="element-191">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8" data-id="element-192">
            De ce am ales să lucrez cu antreprenorii
          </h2>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] text-left" data-id="element-193">
            <p data-id="element-194">
              Am construit companii de la zero. Am ajuns la cifre de milioane.
              Am făcut exit. Și știu exact cum se simte să fii cel mai obosit om
              din firma ta, să iei toate deciziile, să rezolvi toate problemele
              și să îți spui în fiecare seară că mâine va fi altfel.
            </p>
            <p className="font-medium text-[#09111F]" data-id="element-195">
              Nu a fost altfel până nu am pus un sistem în locul improvizației.
            </p>
            <p data-id="element-196">
              Azi fac pentru alți antreprenori ceea ce mi-aș fi dorit eu să facă
              cineva pentru mine: vin cu echipa mea, implementăm PROVI System
              direct în compania ta și nu plecăm până când afacerea nu merge
              fără tine.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 — MISIUNEA MEA */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-197">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-198">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-center mb-12" data-id="element-199">
            De ce există PROVI System
          </h2>
          <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-200">
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-201">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-202">
                Din antreprenor captiv în firmă, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-203">
                  fondator liber
                </strong>
                .
              </p>
            </div>
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-204">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-205">
                Din companie dependentă de om, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-206">
                  business care merge singur
                </strong>
                .
              </p>
            </div>
            <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-6 text-center" data-id="element-207">
              <p className="font-['Inter'] text-[17px] font-light" data-id="element-208">
                Din stagnare și plafonare, la{' '}
                <strong className="font-semibold text-[#3B82F6]" data-id="element-209">
                  creștere predictibilă și garantată
                </strong>
                .
              </p>
            </div>
          </div>
          <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8]" data-id="element-210">
            <p data-id="element-211">
              După ce am construit, eficientizat și vandut propriile afaceri,
              m-am dedicat către lucrul cu antreprenorii care își doresc de la
              afacerile lor, fix ce mi-am dorit eu la început: timp, libertate
              și bani.
            </p>
            <p data-id="element-212">
              Lucrez cu antreprenori mici și mijlocii care au construit o
              afacere ce merge, dar nu merge fără ei în centrul fiecărei
              decizii.
            </p>
            <p data-id="element-213">
              Prin PROVI System, implementam în compania lor cele 8 componente
              care transformă improvizația în sistem, dependența în autonomie și
              plafonul în creștere.
            </p>
            <p className="text-white font-medium" data-id="element-214">
              Prin legea cauzei și efectului, dacă facem ce trebuie să facem,
              rezultatele vin de fiecare dată. Nu există dubiu. Există doar
              sistem și execuție.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 5 — ACREDITĂRI & FORMARE PROFESIONALĂ */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-215">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-216">
          <div className="text-center mb-12" data-id="element-217">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-6" data-id="element-218">
              Formare & Experiență
            </h2>
            <p className="font-['Inter'] text-[19px] font-light text-[#6B7280] max-w-[800px] mx-auto" data-id="element-219">
              Dincolo de diplome, cel mai important activ al meu este experiența
              de a fi construit, condus și vândut companii reale, cu cifre
              reale, în România.
            </p>
          </div>
          <div className="flex flex-col gap-4" data-id="element-220">
            {[{
            text: 'Specialist în Activitatea de Coaching',
            icon: 'M12 14l9-5-9-5-9 5 9 5z M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z'
          }, {
            text: 'Coaching, Training & Public Speaking Certificat Maxwell Leadership',
            icon: 'M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z'
          }, {
            text: 'Certificare DISC — Profilare Comportamentală și Leadership',
            icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z'
          }, {
            text: '12 Ani de Implementare Sisteme de Conducere pentru Companii Românești',
            icon: 'M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z'
          }, {
            text: 'Fondator și Antreprenor cu Exit de Milioane EUR',
            icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
          }].map((cert, i) => <div key={i} className="bg-[#0A1628] rounded-2xl p-6 flex items-center gap-6 border border-[rgba(255,255,255,0.1)] w-full" data-id="element-221">
                <div className="w-12 h-12 rounded-full bg-[rgba(59,130,246,0.2)] flex items-center justify-center flex-shrink-0 text-[#3B82F6]" data-id="element-222">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-223">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d={cert.icon} data-id="element-224" />
                  </svg>
                </div>
                <p className="font-['Montserrat'] text-[16px] font-semibold text-white" data-id="element-225">
                  {cert.text}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 7 — CTA FINAL */}
      <FooterCTA title="Compania ta merită să funcționeze fără să fii tu prezent în fiecare zi." subtitle="Rezervă o sesiune de diagnostic gratuit. În 60 de minute analizăm împreună situația reală a afacerii tale și îți spun exact ce lipsește și care e primul pas concret." buttonText="Rezervă Diagnosticarea Gratuită" data-id="element-226" />
    </div>;
}